/**
 * The Accounts screen's words for a caller the sync is not offered to — in place of the
 * button, so the screen says why there is none instead of answering «forbidden» after a
 * press (the TikTok console's map of the SPA's second wave, audits/2026-10-20/SUMMARY.md
 * at 09:59–10:00Z).
 */
export const SYNC_ADMIN_ONLY =
	"Pulling accounts from TikTok is a platform admin's action: the console refuses it to every other role. The list below is the last sync — a platform admin can pull a refresh.";

/*
 * The page's description and its empty sentence, for the same caller. Both told every
 * reader to pull a refresh — an action the screen offers to a platform admin alone — so
 * a caller without the button reads who pulls instead of being told to.
 */
export const ABOUT_NOT_ADMIN =
	"Read from the console's own database, not from TikTok on every load. A platform admin pulls a refresh when the advertisers the console can reach change.";

export const EMPTY_NOT_ADMIN =
	"Nothing synced yet. Once the TikTok app is approved and the access token configured, a platform admin can pull a refresh, and the advertisers the console's TikTok app is authorised on will be listed.";
